<template>
  <div class='testimonial'>
    <div class='quote-line'>
        <div class='quote-box'><font-awesome-icon :icon="faQuoteLeft" /> </div>
        <div class='testimonial-text'><div class='testimonial-date'> {{ when }} </div><slot></slot> </div>
    </div>
  </div>
</template>
<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import faQuoteLeft from '@fortawesome/fontawesome-free-solid/faQuoteLeft'

export default {
  props: ['when'],
  data () {
    return { faQuoteLeft }
  },
  components: { FontAwesomeIcon }
}
</script>

<style lang="less" scoped>

@import '../css/globals.less';


div.quote-line {
  display: flex;
  flex-direction: row;
  padding: 0.5em 1em;
  width: 75vw;
  min-width: 200px;
}

div.quote-box {
  flex: 0 1 30pt;
}

div.testimonial {
  display: flex;
  padding: 1em;
  justify-content: center;
  align-items: center;
}

div.testimonial-date {
  font-weight: normal;
  font-size: 20pt;
  color: rgb(104, 61, 33);
  padding-bottom: 0.5em;
}

div.testimonial-text {
  color: #44558b;
  padding: 0.2em;
  flex: 1 1 0;
  font-size: 14pt;
}
</style>


// WEBPACK FOOTER //
// src/components/Testimonial.vue